<div class="mb-1 text-neutral-300 paragraph-2">
  <span class="font-bold text-neutral-500">Крок {{ currentStep() }}</span> з 2
</div>
<h2 class="mb-6">Вхід за допомогою DepositSign</h2>

@if (!loading()) {
  @switch (currentStep()) {
    @case (authSteps.Key) {
      <ng-container *ngTemplateOutlet="keyStepTemplate"></ng-container>
    }
    @default {
      <ng-container *ngTemplateOutlet="credentialsStepTemplate"></ng-container>
    }
  }
} @else {
  <div class="flex h-64 items-center justify-center">
    <shared-loader></shared-loader>
  </div>
}

<!-- Credentials step template -->
<ng-template #credentialsStepTemplate>
  <h4 class="mb-6">Авторизуйтесь у DepositSign</h4>
  <form
    class="flex w-full flex-col gap-1"
    [formGroup]="credentialsForm"
    (ngSubmit)="submitCredentials()"
  >
    <mat-form-field>
      <mat-label>Вкажіть логін</mat-label>
      <input
        matInput
        type="tel"
        formControlName="phoneNumber"
      />
    </mat-form-field>
    <mat-form-field>
      <mat-label>Вкажіть пароль</mat-label>
      <input
        matInput
        type="password"
        formControlName="password"
      />
    </mat-form-field>

    <div class="flex justify-end">
      <button class="btn btn-primary">Продовжити</button>
    </div>
  </form>
</ng-template>
<!-- End of credentials step template -->

<!-- Key step template -->
<ng-template #keyStepTemplate>
  <h4 class="mb-6">Авторизуйтесь у кабінеті ХМ за допомогою ключа</h4>
  <form
    class="flex flex-col gap-1"
    [formGroup]="keyForm"
    (ngSubmit)="submitKey(credentialsForm.getRawValue().phoneNumber!, keyForm.getRawValue())"
  >
    <mat-form-field
      class="w-full"
      [ngClass]="{ 'mb-21': !keyForm.get('key').value }"
    >
      <mat-label>Виберіть ключ</mat-label>
      <mat-select formControlName="key">
        @for (key of dsCredentialsResponse!.KeysInfo; track key.KeyName) {
          <mat-option [value]="key">
            @if (key.CertificatesInformation[0].Org && key.CertificatesInformation[0].Org.trim().length) {
              {{ key.CertificatesInformation[0].Org }} ,
            }
            @if (key.CertificatesInformation[0].FullName && key.CertificatesInformation[0].FullName.trim().length) {
              {{ key.CertificatesInformation[0].FullName }}
            }
            @if (key.CertificatesInformation[0].OrgUnit && key.CertificatesInformation[0].OrgUnit.trim().length) {
              , {{ key.CertificatesInformation[0].OrgUnit }}
            }
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    @if (!!keyForm.get("key").value) {
      <mat-form-field class="w-full">
        <mat-label>Вкажіть пароль від ключа</mat-label>
        <input
          matInput
          type="password"
          formControlName="password"
        />
      </mat-form-field>
    }
    <div class="flex justify-between">
      <span
        class="flex cursor-pointer items-center"
        (click)="changeStep(authSteps.Credentials)"
      >
        <mat-icon>arrow_left</mat-icon>
        Змінити обліковий запис DepositSign
      </span>
      <button class="btn btn-primary">Увійти</button>
    </div>
  </form>
</ng-template>
<!-- End of key step template -->
